import type { ReactElement } from "react";

export type AvatarShape = "circle" | "hex" | "square" | "diamond";

export interface AvatarProps {
  kid: { name: string; color: string; avatarShape: AvatarShape };
  size?: number;
}

export function Avatar({ kid, size = 48 }: AvatarProps): ReactElement {
  const initial = kid.name[0] ?? "?";
  const bg = kid.color;
  let shape: ReactElement;
  if (kid.avatarShape === "hex") {
    shape = <polygon points="24,4 42,14 42,34 24,44 6,34 6,14" fill={bg} />;
  } else if (kid.avatarShape === "square") {
    shape = <rect x="4" y="4" width="40" height="40" rx="10" fill={bg} />;
  } else if (kid.avatarShape === "diamond") {
    shape = <polygon points="24,3 45,24 24,45 3,24" fill={bg} />;
  } else {
    shape = <circle cx="24" cy="24" r="22" fill={bg} />;
  }
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" style={{ display: "block" }}>
      {shape}
      <text
        x="24"
        y="24"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="Fraunces, serif"
        fontWeight="600"
        fontSize="22"
        fill="white"
      >
        {initial}
      </text>
    </svg>
  );
}
